var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.36495,
    cy: 5.3171,
    r: 4.42843,
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3966 18.316C17.3207 16.1423 16.3844 14.0878 14.7937 12.6045C13.203 11.1211 11.0883 10.3305 8.9146 10.4064C6.74094 10.4823 4.68646 11.4186 3.20312 13.0092C1.71978 14.5999 0.929096 16.7147 1.005 18.8884",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5022 4.16895L21.5022 12.3697",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6025 8.26953L17.4017 8.26953",
    stroke: "#575757",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMember);
export default __webpack_public_path__ + "static/media/add_member.2befca96e54bb20399f01c4d188ccf05.svg";
export { ForwardRef as ReactComponent };